module.exports = __webpack_public_path__ + "static/media/live-stream-bg.e3735eca.png";